import { isWindowDefined } from '@chegg/utils'
import { Document } from '@tiptap/extension-document'
import { EDITOR_WORD_LIMIT } from '@chegg-wt/core-wa/constants/paraphraser'
import { Editor } from '@tiptap/react'
import type { EditorProps } from '@tiptap/pm/view'
import { Text } from '@tiptap/extension-text'
import { Paragraph } from '@tiptap/extension-paragraph'
import { EditorPlaceholder } from '@chegg-wt/core/extensions/placeholder'
import BubbleMenu from '@tiptap/extension-bubble-menu'
import Typography from '@tiptap/extension-typography'
import smartquotes from 'smartquotes'
import { CustomUnderline, CustomHighlight } from './tipTapExtensions'
import { WordCountLimit } from './tipTapExtensions/WordCountLimit'
import { stripAllMarksFromSlice } from './tiptapUtils'
import { PreventInputRuleUndo } from './tipTapExtensions/PreventInputRuleUndo'

const getEditor = () => {
  const extensions = [
    Document,
    Text,
    Paragraph,
    Typography.configure({
      emDash: false,
      ellipsis: false,
      leftArrow: false,
      rightArrow: false,
      copyright: false,
      registeredTrademark: false,
      trademark: false,
      servicemark: false,
      oneHalf: false,
      oneQuarter: false,
      threeQuarters: false,
      plusMinus: false,
      notEqual: false,
      laquo: false,
      raquo: false,
      multiplication: false,
      superscriptTwo: false,
      superscriptThree: false,
    }),
    EditorPlaceholder,
    BubbleMenu,
    CustomUnderline,
    CustomHighlight,
    PreventInputRuleUndo,
    WordCountLimit.configure({ limit: EDITOR_WORD_LIMIT }),
  ]
  let editor: Editor | null = null

  const editorProps: EditorProps = {
    transformPastedText(text) {
      const sanitisedText = text.replace(/(<([^>]+)>)/gi, '')
      const replacedQuotesToSmartQuotesText = smartquotes(sanitisedText)
      return replacedQuotesToSmartQuotesText
    },
    transformPasted(slice, view) {
      return stripAllMarksFromSlice(slice, view)
    },
    transformCopied(slice, view) {
      return stripAllMarksFromSlice(slice, view)
    },
  }
  return (): Editor | null => {
    if (isWindowDefined) {
      if (!editor) {
        editor = new Editor({
          extensions,
          editorProps,
          content: '',
          onCreate: ({ editor }) => {
            editor.view.dom.setAttribute('spellcheck', 'false')
            editor.view.dom.setAttribute('autocomplete', 'off')
            editor.view.dom.setAttribute('autocapitalize', 'off')
          },
        })
      }
      return editor
    }
    return null
  }
}

const getFeatureEditor = getEditor()

export default getFeatureEditor
